<ngx-chart-legend [legendItems]="chartLegend"></ngx-chart-legend>

<nb-select
  class="period-select"
  [selected]="type"
  (selectedChange)="changePeriod($event)"
>
  <nb-option *ngFor="let period of types" [value]="period">
    {{ period }}
  </nb-option>
</nb-select>
